import { createApp, inject } from "vue";
import "weui";
import "weui/dist/style/weui.min.css";
import "amfe-flexible";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vant from "./common/vantui"; // 移动端适配

const app = createApp(App);
// 全局注册组件
import NavBar from "@/components/navBar/index.vue";
import Improt from "@/components/import/index.vue";
import datePopup from "@/components/datePopup/index.vue";

import { PullRefresh } from 'vant';

app.component("NavBar", NavBar);
app.component("Improt", Improt);
app.component("datePopup", datePopup);

// import VConsole from "vconsole";
// const vconsole = new VConsole() as any;
// .use(vconsole)

  // import 'vue-cropper/dist/index.css'
// import VueCropper from 'vue-cropper'; 
// .use(VueCropper)

// const EventBus = {
//   install(appStore: any) {
//     const eventBus = createApp({});
//     appStore.provide("eventBus", eventBus);
//   },
//   useEventBus() {
//     const eventBus = inject("eventBus");
//     if (!eventBus) {
//       throw new Error("Event Bus not found");
//     }
//     return eventBus;
//   },
// };

app.use(store).use(PullRefresh).use(router).use(vant).mount("#app");
